import { render, staticRenderFns } from "./DropUserOnProjectModal.vue?vue&type=template&id=ad86b5f4"
import script from "./DropUserOnProjectModal.vue?vue&type=script&lang=js"
export * from "./DropUserOnProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports